import { Component, ElementRef, EventEmitter, Output, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/services/admin/admin.service';
import { AppService } from 'src/app/services/app/app.service';
// import { faEllipsis, faPlus, faBell, faQrcode } from '@fortawesome/free-solid-svg-icons'
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { QrModalComponent } from 'src/app/components/layout/qr-modal/qr-modal.component'; 

import { CreateUpdateModalComponent } from 'src/app/components/layout/create-update-modal/create-update-modal.component'; 

import { ThemeService } from 'src/app/services/theme/theme.service';
import { LanguagesService } from 'src/app/services/languages/languages.service';
import { catchError, map, Observable, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { CreateAppComponent } from './create-app/create-app.component';
import { SpinnerComponent } from '../../layout/spinner/spinner.component';
import { ErrorComponent } from '../../layout/error/error.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-myapps',
  standalone: true,
  imports: [
    CreateAppComponent,
    SpinnerComponent,
    ErrorComponent,
    CommonModule,
    FormsModule,
    TranslateModule,
    RouterLink
  ],
  templateUrl: './myapps.component.html',
  styleUrls: ['./myapps.component.css']
})
export class MyappsComponent {

  load = false

  load_qr = false
  load_delete = false

  data: any
  error = false
  qrCodeData!: string;

  domain: string = ''
  isDomainValid: boolean = false;
  isDomainTaken: boolean = false;


  selectedItem: any = null; // არჩეული ელემენტი
  selectedColor: string = '#56a956'; // სტანდარტული ფერი


  selectedLanguage: any

  updateLoad = false

  payModalRef: NgbModalRef | null = null;

  load_check = false
 
  constructor(
    public AppService: AppService,
    private admin: AdminService,
    private toastr: ToastrService,
    private router: Router,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private ThemeService: ThemeService,
    private languageService: LanguagesService,
  ){
    this.get()

    this.activatedRoute.params.subscribe(
      params => {

        var result = params['result']

        if (result === 'success') {
          this.toastr.success('გადახდა წარმატებით განხორციელდა')
  
        }

        if (result === 'fail') {
          this.toastr.error('გადახდა წარუმატებელია')
        }

      }
    );

    this.languageService.selectedLanguage$.subscribe((language) => {
      this.selectedLanguage = language;
    });

  }


  onDomainInput(event: Event) {
    const input = (event.target as HTMLInputElement).value;
    const domainRegex = /^(?!-)(?!.*--)[a-z0-9-]{1,63}(?<!-)$/;

    this.isDomainValid = domainRegex.test(input);
    this.isDomainTaken = false;

   
  }

  
  // Open QR Modal
  openQrModal(item: any) {
    const modalRef = this.modalService.open(QrModalComponent, { size: 'lg' });
    modalRef.componentInstance.qrItem = item;  // Pass item data to the modal
    this.getColor(item.id).subscribe(color => {
      modalRef.componentInstance.qrColor = color;
    });
    // modalRef.componentInstance.qrColor = this.getColor(item.id)  // Default color
  }

  openPayModal(item: any) {
    if(item?.create){
      this.checkDomain(item.sub_domain)
    }else{
      const modalRef = this.modalService.open(CreateUpdateModalComponent, { size: 'lg' });
      modalRef.componentInstance.payitem = item;
    }
  }

  checkDomain(sub_domain: string){
    this.load_check = true
    this.AppService.checkDoamin(sub_domain).subscribe(
      (res: any) => {
        this.load_check = false

        if(res.message == 'app.domain_ok'){
          this.toastr.error('დომენი დაკავებულია')
          this.isDomainTaken = true;
        }else {
          this.isDomainTaken = false;
          const modalRef = this.modalService.open(CreateUpdateModalComponent, { size: 'lg' });
          modalRef.componentInstance.payitem = {'sub_domain': sub_domain, 'create': true};
        }

      },
      (error: any) => {
        this.load_check = false
        if(error.error.message == 'app.payment_required'){
           this.toastr.error('გთხოვთ გადაიხადოთ წინა გადასახადი')
        }
        
      }
    )
  }

  getColor(id: string): Observable<string> {
    return this.AppService.getInfo(id, this.admin.user.id.toString()).pipe(
      map((res: any) => res.color ? res.color : '000'),
      catchError(() => of('000')) // შეცდომის შემთხვევაში დააბრუნებს '000'
    );
  }

  get(){
    const userId = this.admin.user?.id;
    if (userId !== undefined && userId !== null) {
      this.load = true
      this.AppService.show(userId.toString()).subscribe(
        (res: any) => {
          this.load = false
          this.error = false
          this.data = res
          console.log('data: ',this.data)
        },
        (error: any) => {
          console.log(error)
          this.error = true
          this.load = false
        }
      )
    } else {
      console.error('user_id is undefined or null');
      // Handle the undefined or null case appropriately
    }
  }

  delete(domainNAme: string, id: number) {
    if(confirm("Do you really want to delete the domain " + domainNAme + '.menuload.com' + '?')){
      this.load_delete = true;
      const data = {
        id: id,
        subdomain: domainNAme
      }
      this.AppService.delete(data).subscribe(
        (res: any) => {
          this.load_delete = false;
          this.get()
          this.toastr.success(res.message)
          console.log(res)

        },
        (error: any) => {
          this.load_delete = false;
          console.log(error)
          this.toastr.error(error.error)
        }
      );
    }
  }

  createQR(item: any) {
    item.loading = true;
    this.AppService.createQr(item.sub_domain).subscribe(
      (res: any) => {
        item.loading = false;
        item.qr_code = res.qrCode; // განახლებული QR კოდი კონკრეტულ ელემენტში
        this.toastr.success(res.message);
      },
      (error: any) => {
        item.loading = false;
        this.toastr.error(error.error);
      }
    );
  }

  updateSite(domain:  string, id: number){
    const data = {
      subdomain: domain,
      app_id: id,
      user_id: 1,
    }
    this.updateLoad = true

    this.AppService.setApp(data).subscribe(
      (res: any) => {
        console.log(res)
        this.updateLoad = false
        this.toastr.success('წარმატებით განახლდა')
      },
      (error: any) => {
        this.updateLoad = false
      }
     )
  }

  navigateToProducts(itemId: string) {
    this.router.navigate(['/app/products', itemId]);
  }

}
